//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Modal, Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class GenericModal extends React.Component {
  render() {
    const { history, location, title, subtitle, action, to, onClick, onClose } =
      this.props;
    const componentClasses = classNames(styles.GenericModal);

    return (
      <Modal.Base
        className={componentClasses}
        onClose={onClose || (() => history.push(location.state.from))}
      >
        <h2 className={styles.Title}>{title}</h2>
        <span className={styles.Subtitle}>{subtitle}</span>
        {action && (
          <Button style={ButtonStyle.GenBtn} to={to} onClick={onClick}>
            {action}
          </Button>
        )}
      </Modal.Base>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withRouter(GenericModal);
